import { Player } from "../models/Player";

export const players: Player[] = [
  {
    "id": "bijan-robinson",
    "name": "Bijan Robinson",
    "position": "RB",
    "team": "ATL",
    "imageUrl": ""
  },
  {
    "id": "josh-allen",
    "name": "Josh Allen",
    "position": "QB",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "jamarr-chase",
    "name": "Ja'Marr Chase",
    "position": "WR",
    "team": "CIN",
    "imageUrl": ""
  },
  {
    "id": "jaxon-smith-njigba",
    "name": "Jaxon Smith-Njigba",
    "position": "WR",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "jahmyr-gibbs",
    "name": "Jahmyr Gibbs",
    "position": "RB",
    "team": "DET",
    "imageUrl": ""
  },
  {
    "id": "drake-maye",
    "name": "Drake Maye",
    "position": "QB",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "puka-nacua",
    "name": "Puka Nacua",
    "position": "WR",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "brock-bowers",
    "name": "Brock Bowers",
    "position": "TE",
    "team": "LVR",
    "imageUrl": ""
  },
  {
    "id": "malik-nabers",
    "name": "Malik Nabers",
    "position": "WR",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "jayden-daniels",
    "name": "Jayden Daniels",
    "position": "QB",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "caleb-williams",
    "name": "Caleb Williams",
    "position": "QB",
    "team": "CHI",
    "imageUrl": ""
  },
  {
    "id": "justin-jefferson",
    "name": "Justin Jefferson",
    "position": "WR",
    "team": "MIN",
    "imageUrl": ""
  },
  {
    "id": "amon-ra-st-brown",
    "name": "Amon-Ra St. Brown",
    "position": "WR",
    "team": "DET",
    "imageUrl": ""
  },
  {
    "id": "lamar-jackson",
    "name": "Lamar Jackson",
    "position": "QB",
    "team": "BAL",
    "imageUrl": ""
  },
  {
    "id": "ashton-jeanty",
    "name": "Ashton Jeanty",
    "position": "RB",
    "team": "LVR",
    "imageUrl": ""
  },
  {
    "id": "jeremiyah-love",
    "name": "Jeremiyah Love",
    "position": "RB",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "trey-mcbride",
    "name": "Trey McBride",
    "position": "TE",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "joe-burrow",
    "name": "Joe Burrow",
    "position": "QB",
    "team": "CIN",
    "imageUrl": ""
  },
  {
    "id": "ceedee-lamb",
    "name": "CeeDee Lamb",
    "position": "WR",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "drake-london",
    "name": "Drake London",
    "position": "WR",
    "team": "ATL",
    "imageUrl": ""
  },
  {
    "id": "patrick-mahomes",
    "name": "Patrick Mahomes",
    "position": "QB",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "devon-achane",
    "name": "De'Von Achane",
    "position": "RB",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "justin-herbert",
    "name": "Justin Herbert",
    "position": "QB",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "omarion-hampton",
    "name": "Omarion Hampton",
    "position": "RB",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "tetairoa-mcmillan",
    "name": "Tetairoa McMillan",
    "position": "WR",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "jaxson-dart",
    "name": "Jaxson Dart",
    "position": "QB",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "bo-nix",
    "name": "Bo Nix",
    "position": "QB",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "trevor-lawrence",
    "name": "Trevor Lawrence",
    "position": "QB",
    "team": "JAC",
    "imageUrl": ""
  },
  {
    "id": "jalen-hurts",
    "name": "Jalen Hurts",
    "position": "QB",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "james-cook",
    "name": "James Cook",
    "position": "RB",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "emeka-egbuka",
    "name": "Emeka Egbuka",
    "position": "WR",
    "team": "TBB",
    "imageUrl": ""
  },
  {
    "id": "colston-loveland",
    "name": "Colston Loveland",
    "position": "TE",
    "team": "CHI",
    "imageUrl": ""
  },
  {
    "id": "jonathan-taylor",
    "name": "Jonathan Taylor",
    "position": "RB",
    "team": "IND",
    "imageUrl": ""
  },
  {
    "id": "george-pickens",
    "name": "George Pickens",
    "position": "WR",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "brock-purdy",
    "name": "Brock Purdy",
    "position": "QB",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "garrett-wilson",
    "name": "Garrett Wilson",
    "position": "WR",
    "team": "NYJ",
    "imageUrl": ""
  },
  {
    "id": "tyler-warren",
    "name": "Tyler Warren",
    "position": "TE",
    "team": "IND",
    "imageUrl": ""
  },
  {
    "id": "jordan-love",
    "name": "Jordan Love",
    "position": "QB",
    "team": "GBP",
    "imageUrl": ""
  },
  {
    "id": "carnell-tate",
    "name": "Carnell Tate",
    "position": "WR",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "fernando-mendoza",
    "name": "Fernando Mendoza",
    "position": "QB",
    "team": "LVR",
    "imageUrl": ""
  },
  {
    "id": "nico-collins",
    "name": "Nico Collins",
    "position": "WR",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "chris-olave",
    "name": "Chris Olave",
    "position": "WR",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "kenneth-walker-iii",
    "name": "Kenneth Walker III",
    "position": "RB",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "treveyon-henderson",
    "name": "TreVeyon Henderson",
    "position": "RB",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "quinshon-judkins",
    "name": "Quinshon Judkins",
    "position": "RB",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "ladd-mcconkey",
    "name": "Ladd McConkey",
    "position": "WR",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "rome-odunze",
    "name": "Rome Odunze",
    "position": "WR",
    "team": "CHI",
    "imageUrl": ""
  },
  {
    "id": "breece-hall",
    "name": "Breece Hall",
    "position": "RB",
    "team": "NYJ",
    "imageUrl": ""
  },
  {
    "id": "luther-burden",
    "name": "Luther Burden",
    "position": "WR",
    "team": "CHI",
    "imageUrl": ""
  },
  {
    "id": "cam-ward",
    "name": "Cam Ward",
    "position": "QB",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "rashee-rice",
    "name": "Rashee Rice",
    "position": "WR",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "jordyn-tyson",
    "name": "Jordyn Tyson",
    "position": "WR",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "devonta-smith",
    "name": "DeVonta Smith",
    "position": "WR",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "makai-lemon",
    "name": "Makai Lemon",
    "position": "WR",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "marvin-harrison-jr",
    "name": "Marvin Harrison Jr.",
    "position": "WR",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "christian-mccaffrey",
    "name": "Christian McCaffrey",
    "position": "RB",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "bucky-irving",
    "name": "Bucky Irving",
    "position": "RB",
    "team": "TBB",
    "imageUrl": ""
  },
  {
    "id": "brian-thomas-jr",
    "name": "Brian Thomas Jr.",
    "position": "WR",
    "team": "JAC",
    "imageUrl": ""
  },
  {
    "id": "saquon-barkley",
    "name": "Saquon Barkley",
    "position": "RB",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "dak-prescott",
    "name": "Dak Prescott",
    "position": "QB",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "cj-stroud",
    "name": "C.J. Stroud",
    "position": "QB",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "chase-brown",
    "name": "Chase Brown",
    "position": "RB",
    "team": "CIN",
    "imageUrl": ""
  },
  {
    "id": "jaylen-waddle",
    "name": "Jaylen Waddle",
    "position": "WR",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "kyren-williams",
    "name": "Kyren Williams",
    "position": "RB",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "tee-higgins",
    "name": "Tee Higgins",
    "position": "WR",
    "team": "CIN",
    "imageUrl": ""
  },
  {
    "id": "harold-fannin",
    "name": "Harold Fannin",
    "position": "TE",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "aj-brown",
    "name": "A.J. Brown",
    "position": "WR",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "tyler-shough",
    "name": "Tyler Shough",
    "position": "QB",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "baker-mayfield",
    "name": "Baker Mayfield",
    "position": "QB",
    "team": "TBB",
    "imageUrl": ""
  },
  {
    "id": "tucker-kraft",
    "name": "Tucker Kraft",
    "position": "TE",
    "team": "GBP",
    "imageUrl": ""
  },
  {
    "id": "jameson-williams",
    "name": "Jameson Williams",
    "position": "WR",
    "team": "DET",
    "imageUrl": ""
  },
  {
    "id": "sam-darnold",
    "name": "Sam Darnold",
    "position": "QB",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "zay-flowers",
    "name": "Zay Flowers",
    "position": "WR",
    "team": "BAL",
    "imageUrl": ""
  },
  {
    "id": "jared-goff",
    "name": "Jared Goff",
    "position": "QB",
    "team": "DET",
    "imageUrl": ""
  },
  {
    "id": "sam-laporta",
    "name": "Sam LaPorta",
    "position": "TE",
    "team": "DET",
    "imageUrl": ""
  },
  {
    "id": "jadarian-price",
    "name": "Jadarian Price",
    "position": "RB",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "bryce-young",
    "name": "Bryce Young",
    "position": "QB",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "josh-jacobs",
    "name": "Josh Jacobs",
    "position": "RB",
    "team": "GBP",
    "imageUrl": ""
  },
  {
    "id": "cam-skattebo",
    "name": "Cam Skattebo",
    "position": "RB",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "travis-etienne",
    "name": "Travis Etienne",
    "position": "RB",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "javonte-williams",
    "name": "Javonte Williams",
    "position": "RB",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "kyle-pitts",
    "name": "Kyle Pitts",
    "position": "TE",
    "team": "ATL",
    "imageUrl": ""
  },
  {
    "id": "kc-concepcion",
    "name": "KC Concepcion",
    "position": "WR",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "alec-pierce",
    "name": "Alec Pierce",
    "position": "WR",
    "team": "IND",
    "imageUrl": ""
  },
  {
    "id": "kyler-murray",
    "name": "Kyler Murray",
    "position": "QB",
    "team": "MIN",
    "imageUrl": ""
  },
  {
    "id": "malik-willis",
    "name": "Malik Willis",
    "position": "QB",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "kenyon-sadiq",
    "name": "Kenyon Sadiq",
    "position": "TE",
    "team": "NYJ",
    "imageUrl": ""
  },
  {
    "id": "daniel-jones",
    "name": "Daniel Jones",
    "position": "QB",
    "team": "IND",
    "imageUrl": ""
  },
  {
    "id": "jordan-addison",
    "name": "Jordan Addison",
    "position": "WR",
    "team": "MIN",
    "imageUrl": ""
  },
  {
    "id": "bhayshul-tuten",
    "name": "Bhayshul Tuten",
    "position": "RB",
    "team": "JAC",
    "imageUrl": ""
  },
  {
    "id": "oronde-gadsden",
    "name": "Oronde Gadsden",
    "position": "TE",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "derrick-henry",
    "name": "Derrick Henry",
    "position": "RB",
    "team": "BAL",
    "imageUrl": ""
  },
  {
    "id": "omar-cooper-jr",
    "name": "Omar Cooper Jr.",
    "position": "WR",
    "team": "NYJ",
    "imageUrl": ""
  },
  {
    "id": "dj-moore",
    "name": "D.J. Moore",
    "position": "WR",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "matthew-golden",
    "name": "Matthew Golden",
    "position": "WR",
    "team": "GBP",
    "imageUrl": ""
  },
  {
    "id": "dk-metcalf",
    "name": "DK Metcalf",
    "position": "WR",
    "team": "PIT",
    "imageUrl": ""
  },
  {
    "id": "rj-harvey",
    "name": "RJ Harvey",
    "position": "RB",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "michael-wilson",
    "name": "Michael Wilson",
    "position": "WR",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "ty-simpson",
    "name": "Ty Simpson",
    "position": "QB",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "matthew-stafford",
    "name": "Matthew Stafford",
    "position": "QB",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "christian-watson",
    "name": "Christian Watson",
    "position": "WR",
    "team": "GBP",
    "imageUrl": ""
  },
  {
    "id": "wandale-robinson",
    "name": "Wan'Dale Robinson",
    "position": "WR",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "kyle-monangai",
    "name": "Kyle Monangai",
    "position": "RB",
    "team": "CHI",
    "imageUrl": ""
  },
  {
    "id": "dandre-swift",
    "name": "D'Andre Swift",
    "position": "RB",
    "team": "CHI",
    "imageUrl": ""
  },
  {
    "id": "jayden-higgins",
    "name": "Jayden Higgins",
    "position": "WR",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "ricky-pearsall",
    "name": "Ricky Pearsall",
    "position": "WR",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "zach-charbonnet",
    "name": "Zach Charbonnet",
    "position": "RB",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "terry-mclaurin",
    "name": "Terry McLaurin",
    "position": "WR",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "parker-washington",
    "name": "Parker Washington",
    "position": "WR",
    "team": "JAC",
    "imageUrl": ""
  },
  {
    "id": "davante-adams",
    "name": "Davante Adams",
    "position": "WR",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "josh-downs",
    "name": "Josh Downs",
    "position": "WR",
    "team": "IND",
    "imageUrl": ""
  },
  {
    "id": "eli-stowers",
    "name": "Eli Stowers",
    "position": "TE",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "george-kittle",
    "name": "George Kittle",
    "position": "TE",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "quentin-johnston",
    "name": "Quentin Johnston",
    "position": "WR",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "xavier-worthy",
    "name": "Xavier Worthy",
    "position": "WR",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "denzel-boston",
    "name": "Denzel Boston",
    "position": "WR",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "michael-pittman",
    "name": "Michael Pittman",
    "position": "WR",
    "team": "PIT",
    "imageUrl": ""
  },
  {
    "id": "david-montgomery",
    "name": "David Montgomery",
    "position": "RB",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "isaiah-likely",
    "name": "Isaiah Likely",
    "position": "TE",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "chuba-hubbard",
    "name": "Chuba Hubbard",
    "position": "RB",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "jayden-reed",
    "name": "Jayden Reed",
    "position": "WR",
    "team": "GBP",
    "imageUrl": ""
  },
  {
    "id": "romeo-doubs",
    "name": "Romeo Doubs",
    "position": "WR",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "mike-evans",
    "name": "Mike Evans",
    "position": "WR",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "travis-hunter",
    "name": "Travis Hunter",
    "position": "WR",
    "team": "JAC",
    "imageUrl": ""
  },
  {
    "id": "jake-ferguson",
    "name": "Jake Ferguson",
    "position": "TE",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "courtland-sutton",
    "name": "Courtland Sutton",
    "position": "WR",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "jakobi-meyers",
    "name": "Jakobi Meyers",
    "position": "WR",
    "team": "JAC",
    "imageUrl": ""
  },
  {
    "id": "dalton-kincaid",
    "name": "Dalton Kincaid",
    "position": "TE",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "blake-corum",
    "name": "Blake Corum",
    "position": "RB",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "rico-dowdle",
    "name": "Rico Dowdle",
    "position": "RB",
    "team": "PIT",
    "imageUrl": ""
  },
  {
    "id": "jaylen-warren",
    "name": "Jaylen Warren",
    "position": "RB",
    "team": "PIT",
    "imageUrl": ""
  },
  {
    "id": "michael-penix-jr",
    "name": "Michael Penix Jr.",
    "position": "QB",
    "team": "ATL",
    "imageUrl": ""
  },
  {
    "id": "jk-dobbins",
    "name": "J.K. Dobbins",
    "position": "RB",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "rashid-shaheed",
    "name": "Rashid Shaheed",
    "position": "WR",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "jalen-coker",
    "name": "Jalen Coker",
    "position": "WR",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "jalen-mcmillan",
    "name": "Jalen McMillan",
    "position": "WR",
    "team": "TBB",
    "imageUrl": ""
  },
  {
    "id": "brenton-strange",
    "name": "Brenton Strange",
    "position": "TE",
    "team": "JAC",
    "imageUrl": ""
  },
  {
    "id": "jonathon-brooks",
    "name": "Jonathon Brooks",
    "position": "RB",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "khalil-shakir",
    "name": "Khalil Shakir",
    "position": "WR",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "jj-mccarthy",
    "name": "J.J. McCarthy",
    "position": "QB",
    "team": "MIN",
    "imageUrl": ""
  },
  {
    "id": "chris-godwin",
    "name": "Chris Godwin",
    "position": "WR",
    "team": "TBB",
    "imageUrl": ""
  },
  {
    "id": "woody-marks",
    "name": "Woody Marks",
    "position": "RB",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "rhamondre-stevenson",
    "name": "Rhamondre Stevenson",
    "position": "RB",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "jacory-croskey-merritt",
    "name": "Jacory Croskey-Merritt",
    "position": "RB",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "aj-barner",
    "name": "AJ Barner",
    "position": "TE",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "kenneth-gainwell",
    "name": "Kenneth Gainwell",
    "position": "RB",
    "team": "TBB",
    "imageUrl": ""
  },
  {
    "id": "jonah-coleman",
    "name": "Jonah Coleman",
    "position": "RB",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "shedeur-sanders",
    "name": "Shedeur Sanders",
    "position": "QB",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "tj-hockenson",
    "name": "T.J. Hockenson",
    "position": "TE",
    "team": "MIN",
    "imageUrl": ""
  },
  {
    "id": "chigoziem-okonkwo",
    "name": "Chigoziem Okonkwo",
    "position": "TE",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "nicholas-singleton",
    "name": "Nicholas Singleton",
    "position": "RB",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "isaac-teslaa",
    "name": "Isaac TeSlaa",
    "position": "WR",
    "team": "DET",
    "imageUrl": ""
  },
  {
    "id": "mark-andrews",
    "name": "Mark Andrews",
    "position": "TE",
    "team": "BAL",
    "imageUrl": ""
  },
  {
    "id": "kayshon-boutte",
    "name": "Kayshon Boutte",
    "position": "WR",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "tua-tagovailoa",
    "name": "Tua Tagovailoa",
    "position": "QB",
    "team": "ATL",
    "imageUrl": ""
  },
  {
    "id": "mac-jones",
    "name": "Mac Jones",
    "position": "QB",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "troy-franklin",
    "name": "Troy Franklin",
    "position": "WR",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "tony-pollard",
    "name": "Tony Pollard",
    "position": "RB",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "tre-harris",
    "name": "Tre Harris",
    "position": "WR",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "tyler-allgeier",
    "name": "Tyler Allgeier",
    "position": "RB",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "dylan-sampson",
    "name": "Dylan Sampson",
    "position": "RB",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "jaylin-noel",
    "name": "Jaylin Noel",
    "position": "WR",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "jacoby-brissett",
    "name": "Jacoby Brissett",
    "position": "QB",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "elic-ayomanor",
    "name": "Elic Ayomanor",
    "position": "WR",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "chris-bell",
    "name": "Chris Bell",
    "position": "WR",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "tory-horton",
    "name": "Tory Horton",
    "position": "WR",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "terrance-ferguson",
    "name": "Terrance Ferguson",
    "position": "TE",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "jerry-jeudy",
    "name": "Jerry Jeudy",
    "position": "WR",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "tyjae-spears",
    "name": "Tyjae Spears",
    "position": "RB",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "rachaad-white",
    "name": "Rachaad White",
    "position": "RB",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "gunnar-helm",
    "name": "Gunnar Helm",
    "position": "TE",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "jordan-mason",
    "name": "Jordan Mason",
    "position": "RB",
    "team": "MIN",
    "imageUrl": ""
  },
  {
    "id": "jauan-jennings",
    "name": "Jauan Jennings",
    "position": "WR",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "chimere-dike",
    "name": "Chimere Dike",
    "position": "WR",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "braelon-allen",
    "name": "Braelon Allen",
    "position": "RB",
    "team": "NYJ",
    "imageUrl": ""
  },
  {
    "id": "germie-bernard",
    "name": "Germie Bernard",
    "position": "WR",
    "team": "PIT",
    "imageUrl": ""
  },
  {
    "id": "tyrone-tracy",
    "name": "Tyrone Tracy",
    "position": "RB",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "dontayvion-wicks",
    "name": "Dontayvion Wicks",
    "position": "WR",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "dallas-goedert",
    "name": "Dallas Goedert",
    "position": "TE",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "chris-brazzell-ii",
    "name": "Chris Brazzell II",
    "position": "WR",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "adonai-mitchell",
    "name": "Adonai Mitchell",
    "position": "WR",
    "team": "NYJ",
    "imageUrl": ""
  },
  {
    "id": "tre-tucker",
    "name": "Tre Tucker",
    "position": "WR",
    "team": "LVR",
    "imageUrl": ""
  },
  {
    "id": "elijah-arroyo",
    "name": "Elijah Arroyo",
    "position": "TE",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "keon-coleman",
    "name": "Keon Coleman",
    "position": "WR",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "mike-washington-jr",
    "name": "Mike Washington Jr.",
    "position": "RB",
    "team": "LVR",
    "imageUrl": ""
  },
  {
    "id": "brandon-aiyuk",
    "name": "Brandon Aiyuk",
    "position": "WR",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "kaleb-johnson",
    "name": "Kaleb Johnson",
    "position": "RB",
    "team": "PIT",
    "imageUrl": ""
  },
  {
    "id": "kyle-williams",
    "name": "Kyle Williams",
    "position": "WR",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "ollie-gordon",
    "name": "Ollie Gordon",
    "position": "RB",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "keaton-mitchell",
    "name": "Keaton Mitchell",
    "position": "RB",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "tank-bigsby",
    "name": "Tank Bigsby",
    "position": "RB",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "chris-rodriguez",
    "name": "Chris Rodriguez",
    "position": "RB",
    "team": "JAC",
    "imageUrl": ""
  },
  {
    "id": "malik-washington",
    "name": "Malik Washington",
    "position": "WR",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "mason-taylor",
    "name": "Mason Taylor",
    "position": "TE",
    "team": "NYJ",
    "imageUrl": ""
  },
  {
    "id": "david-njoku",
    "name": "David Njoku",
    "position": "TE",
    "team": "FA",
    "imageUrl": ""
  },
  {
    "id": "brian-robinson",
    "name": "Brian Robinson",
    "position": "RB",
    "team": "ATL",
    "imageUrl": ""
  },
  {
    "id": "travis-kelce",
    "name": "Travis Kelce",
    "position": "TE",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "jack-bech",
    "name": "Jack Bech",
    "position": "WR",
    "team": "LVR",
    "imageUrl": ""
  },
  {
    "id": "deebo-samuel",
    "name": "Deebo Samuel",
    "position": "WR",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "malachi-fields",
    "name": "Malachi Fields",
    "position": "WR",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "tank-dell",
    "name": "Tank Dell",
    "position": "WR",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "anthony-richardson",
    "name": "Anthony Richardson",
    "position": "QB",
    "team": "IND",
    "imageUrl": ""
  },
  {
    "id": "jalen-nailor",
    "name": "Jalen Nailor",
    "position": "WR",
    "team": "LVR",
    "imageUrl": ""
  },
  {
    "id": "zachariah-branch",
    "name": "Zachariah Branch",
    "position": "WR",
    "team": "ATL",
    "imageUrl": ""
  },
  {
    "id": "jalen-milroe",
    "name": "Jalen Milroe",
    "position": "QB",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "jake-tonges",
    "name": "Jake Tonges",
    "position": "TE",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "theo-johnson",
    "name": "Theo Johnson",
    "position": "TE",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "juwan-johnson",
    "name": "Juwan Johnson",
    "position": "TE",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "hunter-henry",
    "name": "Hunter Henry",
    "position": "TE",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "cade-otton",
    "name": "Cade Otton",
    "position": "TE",
    "team": "TBB",
    "imageUrl": ""
  },
  {
    "id": "trey-benson",
    "name": "Trey Benson",
    "position": "RB",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "sean-tucker",
    "name": "Sean Tucker",
    "position": "RB",
    "team": "TBB",
    "imageUrl": ""
  },
  {
    "id": "kimani-vidal",
    "name": "Kimani Vidal",
    "position": "RB",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "isiah-pacheco",
    "name": "Isiah Pacheco",
    "position": "RB",
    "team": "DET",
    "imageUrl": ""
  },
  {
    "id": "jaylen-wright",
    "name": "Jaylen Wright",
    "position": "RB",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "marvin-mims",
    "name": "Marvin Mims",
    "position": "WR",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "dalton-schultz",
    "name": "Dalton Schultz",
    "position": "TE",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "emmett-johnson",
    "name": "Emmett Johnson",
    "position": "RB",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "skyler-bell",
    "name": "Skyler Bell",
    "position": "WR",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "aaron-jones",
    "name": "Aaron Jones",
    "position": "RB",
    "team": "MIN",
    "imageUrl": ""
  },
  {
    "id": "tez-johnson",
    "name": "Tez Johnson",
    "position": "WR",
    "team": "TBB",
    "imageUrl": ""
  },
  {
    "id": "michael-mayer",
    "name": "Michael Mayer",
    "position": "TE",
    "team": "LVR",
    "imageUrl": ""
  },
  {
    "id": "jakobi-lane",
    "name": "Ja'Kobi Lane",
    "position": "WR",
    "team": "BAL",
    "imageUrl": ""
  },
  {
    "id": "devin-neal",
    "name": "Devin Neal",
    "position": "RB",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "kaytron-allen",
    "name": "Kaytron Allen",
    "position": "RB",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "trevor-etienne",
    "name": "Trevor Etienne",
    "position": "RB",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "stefon-diggs",
    "name": "Stefon Diggs",
    "position": "WR",
    "team": "FA",
    "imageUrl": ""
  },
  {
    "id": "isaiah-bond",
    "name": "Isaiah Bond",
    "position": "WR",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "darnell-mooney",
    "name": "Darnell Mooney",
    "position": "WR",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "justin-fields",
    "name": "Justin Fields",
    "position": "QB",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "tyreek-hill",
    "name": "Tyreek Hill",
    "position": "WR",
    "team": "FA",
    "imageUrl": ""
  },
  {
    "id": "pat-freiermuth",
    "name": "Pat Freiermuth",
    "position": "TE",
    "team": "PIT",
    "imageUrl": ""
  },
  {
    "id": "geno-smith",
    "name": "Geno Smith",
    "position": "QB",
    "team": "NYJ",
    "imageUrl": ""
  },
  {
    "id": "emanuel-wilson",
    "name": "Emanuel Wilson",
    "position": "RB",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "antonio-williams",
    "name": "Antonio Williams",
    "position": "WR",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "donte-thornton",
    "name": "Dont'e Thornton",
    "position": "WR",
    "team": "LVR",
    "imageUrl": ""
  },
  {
    "id": "jordan-james",
    "name": "Jordan James",
    "position": "RB",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "jatavion-sanders",
    "name": "Ja'Tavion Sanders",
    "position": "TE",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "cole-kmet",
    "name": "Cole Kmet",
    "position": "TE",
    "team": "CHI",
    "imageUrl": ""
  },
  {
    "id": "rashod-bateman",
    "name": "Rashod Bateman",
    "position": "WR",
    "team": "BAL",
    "imageUrl": ""
  },
  {
    "id": "lequint-allen",
    "name": "LeQuint Allen",
    "position": "RB",
    "team": "JAC",
    "imageUrl": ""
  },
  {
    "id": "xavier-legette",
    "name": "Xavier Legette",
    "position": "WR",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "dj-giddens",
    "name": "DJ Giddens",
    "position": "RB",
    "team": "IND",
    "imageUrl": ""
  },
  {
    "id": "christian-kirk",
    "name": "Christian Kirk",
    "position": "WR",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "alvin-kamara",
    "name": "Alvin Kamara",
    "position": "RB",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "jaydon-blue",
    "name": "Jaydon Blue",
    "position": "RB",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "demario-douglas",
    "name": "Demario Douglas",
    "position": "WR",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "colby-parkinson",
    "name": "Colby Parkinson",
    "position": "TE",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "james-conner",
    "name": "James Conner",
    "position": "RB",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "will-howard",
    "name": "Will Howard",
    "position": "QB",
    "team": "PIT",
    "imageUrl": ""
  },
  {
    "id": "cedric-tillman",
    "name": "Cedric Tillman",
    "position": "WR",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "ray-davis",
    "name": "Ray Davis",
    "position": "RB",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "kirk-cousins",
    "name": "Kirk Cousins",
    "position": "QB",
    "team": "LVR",
    "imageUrl": ""
  },
  {
    "id": "jaylin-lane",
    "name": "Jaylin Lane",
    "position": "WR",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "kendre-miller",
    "name": "Kendre Miller",
    "position": "RB",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "calvin-ridley",
    "name": "Calvin Ridley",
    "position": "WR",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "brashard-smith",
    "name": "Brashard Smith",
    "position": "RB",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "evan-engram",
    "name": "Evan Engram",
    "position": "TE",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "darnell-washington",
    "name": "Darnell Washington",
    "position": "TE",
    "team": "PIT",
    "imageUrl": ""
  },
  {
    "id": "deshaun-watson",
    "name": "Deshaun Watson",
    "position": "QB",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "quinn-ewers",
    "name": "Quinn Ewers",
    "position": "QB",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "luke-musgrave",
    "name": "Luke Musgrave",
    "position": "TE",
    "team": "GBP",
    "imageUrl": ""
  },
  {
    "id": "najee-harris",
    "name": "Najee Harris",
    "position": "RB",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "marshawn-lloyd",
    "name": "MarShawn Lloyd",
    "position": "RB",
    "team": "GBP",
    "imageUrl": ""
  },
  {
    "id": "tyquan-thornton",
    "name": "Tyquan Thornton",
    "position": "WR",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "jalen-tolbert",
    "name": "Jalen Tolbert",
    "position": "WR",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "ben-sinnott",
    "name": "Ben Sinnott",
    "position": "TE",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "cooper-kupp",
    "name": "Cooper Kupp",
    "position": "WR",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "aaron-rodgers",
    "name": "Aaron Rodgers",
    "position": "QB",
    "team": "PIT",
    "imageUrl": ""
  },
  {
    "id": "jalen-royals",
    "name": "Jalen Royals",
    "position": "WR",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "riley-leonard",
    "name": "Riley Leonard",
    "position": "QB",
    "team": "IND",
    "imageUrl": ""
  },
  {
    "id": "isaiah-davis",
    "name": "Isaiah Davis",
    "position": "RB",
    "team": "NYJ",
    "imageUrl": ""
  },
  {
    "id": "marquise-brown",
    "name": "Marquise Brown",
    "position": "WR",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "xavier-hutchinson",
    "name": "Xavier Hutchinson",
    "position": "WR",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "garrett-nussmeier",
    "name": "Garrett Nussmeier",
    "position": "QB",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "jahan-dotson",
    "name": "Jahan Dotson",
    "position": "WR",
    "team": "ATL",
    "imageUrl": ""
  },
  {
    "id": "dawson-knox",
    "name": "Dawson Knox",
    "position": "TE",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "tutu-atwell",
    "name": "Tutu Atwell",
    "position": "WR",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "spencer-rattler",
    "name": "Spencer Rattler",
    "position": "QB",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "savion-williams",
    "name": "Savion Williams",
    "position": "WR",
    "team": "GBP",
    "imageUrl": ""
  },
  {
    "id": "max-klare",
    "name": "Max Klare",
    "position": "TE",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "ryan-flournoy",
    "name": "Ryan Flournoy",
    "position": "WR",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "greg-dulcich",
    "name": "Greg Dulcich",
    "position": "TE",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "luke-mccaffrey",
    "name": "Luke McCaffrey",
    "position": "WR",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "joe-milton",
    "name": "Joe Milton",
    "position": "QB",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "jarquez-hunter",
    "name": "Jarquez Hunter",
    "position": "RB",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "ted-hurst",
    "name": "Ted Hurst",
    "position": "WR",
    "team": "TBB",
    "imageUrl": ""
  },
  {
    "id": "roman-wilson",
    "name": "Roman Wilson",
    "position": "WR",
    "team": "PIT",
    "imageUrl": ""
  },
  {
    "id": "andrei-iosivas",
    "name": "Andrei Iosivas",
    "position": "WR",
    "team": "CIN",
    "imageUrl": ""
  },
  {
    "id": "tahj-brooks",
    "name": "Tahj Brooks",
    "position": "RB",
    "team": "CIN",
    "imageUrl": ""
  },
  {
    "id": "john-metchie",
    "name": "John Metchie",
    "position": "WR",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "will-shipley",
    "name": "Will Shipley",
    "position": "RB",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "devaughn-vele",
    "name": "Devaughn Vele",
    "position": "WR",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "joshua-palmer",
    "name": "Joshua Palmer",
    "position": "WR",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "audric-estime",
    "name": "Audric Estime",
    "position": "RB",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "keandre-lambert-smith",
    "name": "KeAndre Lambert-Smith",
    "position": "WR",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "noah-gray",
    "name": "Noah Gray",
    "position": "TE",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "isaac-guerendo",
    "name": "Isaac Guerendo",
    "position": "RB",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "jimmy-horn",
    "name": "Jimmy Horn",
    "position": "WR",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "treylon-burks",
    "name": "Treylon Burks",
    "position": "WR",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "jordan-whittington",
    "name": "Jordan Whittington",
    "position": "WR",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "keenan-allen",
    "name": "Keenan Allen",
    "position": "WR",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "calvin-austin-iii",
    "name": "Calvin Austin III",
    "position": "WR",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "roschon-johnson",
    "name": "Roschon Johnson",
    "position": "RB",
    "team": "CHI",
    "imageUrl": ""
  },
  {
    "id": "jerome-ford",
    "name": "Jerome Ford",
    "position": "RB",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "darius-slayton",
    "name": "Darius Slayton",
    "position": "WR",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "tahj-washington",
    "name": "Tahj Washington",
    "position": "WR",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "dillon-gabriel",
    "name": "Dillon Gabriel",
    "position": "QB",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "will-levis",
    "name": "Will Levis",
    "position": "QB",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "jalynn-polk",
    "name": "Ja'Lynn Polk",
    "position": "WR",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "jaleel-mclaughlin",
    "name": "Jaleel McLaughlin",
    "position": "RB",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "jameis-winston",
    "name": "Jameis Winston",
    "position": "QB",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "tyson-bagent",
    "name": "Tyson Bagent",
    "position": "QB",
    "team": "CHI",
    "imageUrl": ""
  },
  {
    "id": "davis-mills",
    "name": "Davis Mills",
    "position": "QB",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "daniel-bellinger",
    "name": "Daniel Bellinger",
    "position": "TE",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "kendrick-bourne",
    "name": "Kendrick Bourne",
    "position": "WR",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "marcus-mariota",
    "name": "Marcus Mariota",
    "position": "QB",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "konata-mumpfield",
    "name": "Konata Mumpfield",
    "position": "WR",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "dyami-brown",
    "name": "Dyami Brown",
    "position": "WR",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "noah-fant",
    "name": "Noah Fant",
    "position": "TE",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "cade-stover",
    "name": "Cade Stover",
    "position": "TE",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "devontez-walker",
    "name": "Devontez Walker",
    "position": "WR",
    "team": "BAL",
    "imageUrl": ""
  },
  {
    "id": "raheim-sanders",
    "name": "Raheim Sanders",
    "position": "RB",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "efton-chism",
    "name": "Efton Chism",
    "position": "WR",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "mike-gesicki",
    "name": "Mike Gesicki",
    "position": "TE",
    "team": "CIN",
    "imageUrl": ""
  },
  {
    "id": "tommy-tremble",
    "name": "Tommy Tremble",
    "position": "TE",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "tyler-higbee",
    "name": "Tyler Higbee",
    "position": "TE",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "devin-singletary",
    "name": "Devin Singletary",
    "position": "RB",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "cade-klubnik",
    "name": "Cade Klubnik",
    "position": "QB",
    "team": "NYJ",
    "imageUrl": ""
  },
  {
    "id": "kevin-coleman",
    "name": "Kevin Coleman",
    "position": "WR",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "george-holani",
    "name": "George Holani",
    "position": "RB",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "xavier-restrepo",
    "name": "Xavier Restrepo",
    "position": "WR",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "damien-martinez",
    "name": "Damien Martinez",
    "position": "RB",
    "team": "GBP",
    "imageUrl": ""
  },
  {
    "id": "ty-johnson",
    "name": "Ty Johnson",
    "position": "RB",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "justice-hill",
    "name": "Justice Hill",
    "position": "RB",
    "team": "BAL",
    "imageUrl": ""
  },
  {
    "id": "elijah-moore",
    "name": "Elijah Moore",
    "position": "WR",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "malik-davis",
    "name": "Malik Davis",
    "position": "RB",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "jalin-hyatt",
    "name": "Jalin Hyatt",
    "position": "WR",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "demond-claiborne",
    "name": "Demond Claiborne",
    "position": "RB",
    "team": "MIN",
    "imageUrl": ""
  },
  {
    "id": "olamide-zaccheaus",
    "name": "Olamide Zaccheaus",
    "position": "WR",
    "team": "ATL",
    "imageUrl": ""
  },
  {
    "id": "tanner-mckee",
    "name": "Tanner McKee",
    "position": "QB",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "tai-felton",
    "name": "Tai Felton",
    "position": "WR",
    "team": "MIN",
    "imageUrl": ""
  },
  {
    "id": "erick-all",
    "name": "Erick All",
    "position": "TE",
    "team": "CIN",
    "imageUrl": ""
  },
  {
    "id": "greg-dortch",
    "name": "Greg Dortch",
    "position": "WR",
    "team": "DET",
    "imageUrl": ""
  },
  {
    "id": "phil-mafah",
    "name": "Phil Mafah",
    "position": "RB",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "luke-schoonmaker",
    "name": "Luke Schoonmaker",
    "position": "TE",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "bam-knight",
    "name": "Bam Knight",
    "position": "RB",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "malachi-corley",
    "name": "Malachi Corley",
    "position": "WR",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "elijah-higgins",
    "name": "Elijah Higgins",
    "position": "TE",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "tyler-huntley",
    "name": "Tyler Huntley",
    "position": "QB",
    "team": "BAL",
    "imageUrl": ""
  },
  {
    "id": "kameron-johnson",
    "name": "Kameron Johnson",
    "position": "WR",
    "team": "TBB",
    "imageUrl": ""
  },
  {
    "id": "emari-demercado",
    "name": "Emari Demercado",
    "position": "RB",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "trey-palmer",
    "name": "Trey Palmer",
    "position": "WR",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "joe-mixon",
    "name": "Joe Mixon",
    "position": "RB",
    "team": "FA",
    "imageUrl": ""
  },
  {
    "id": "jonnu-smith",
    "name": "Jonnu Smith",
    "position": "TE",
    "team": "FA",
    "imageUrl": ""
  },
  {
    "id": "joe-flacco",
    "name": "Joe Flacco",
    "position": "QB",
    "team": "CIN",
    "imageUrl": ""
  },
  {
    "id": "kavontae-turpin",
    "name": "KaVontae Turpin",
    "position": "WR",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "donovan-edwards",
    "name": "Donovan Edwards",
    "position": "RB",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "mack-hollins",
    "name": "Mack Hollins",
    "position": "WR",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "mitchell-evans",
    "name": "Mitchell Evans",
    "position": "TE",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "gardner-minshew",
    "name": "Gardner Minshew",
    "position": "QB",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "trey-lance",
    "name": "Trey Lance",
    "position": "QB",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "kenny-pickett",
    "name": "Kenny Pickett",
    "position": "QB",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "tyler-goodson",
    "name": "Tyler Goodson",
    "position": "RB",
    "team": "ATL",
    "imageUrl": ""
  },
  {
    "id": "chris-brooks",
    "name": "Chris Brooks",
    "position": "RB",
    "team": "GBP",
    "imageUrl": ""
  },
  {
    "id": "michael-trigg",
    "name": "Michael Trigg",
    "position": "TE",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "dezhaun-stribling",
    "name": "De'Zhaun Stribling",
    "position": "WR",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "jake-bobo",
    "name": "Jake Bobo",
    "position": "WR",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "michael-carter",
    "name": "Michael Carter",
    "position": "RB",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "gabriel-davis",
    "name": "Gabriel Davis",
    "position": "WR",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "rasheen-ali",
    "name": "Rasheen Ali",
    "position": "RB",
    "team": "BAL",
    "imageUrl": ""
  },
  {
    "id": "kalel-mullings",
    "name": "Kalel Mullings",
    "position": "RB",
    "team": "TEN",
    "imageUrl": ""
  },
  {
    "id": "jacob-cowing",
    "name": "Jacob Cowing",
    "position": "WR",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "javon-baker",
    "name": "Javon Baker",
    "position": "WR",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "zach-wilson",
    "name": "Zach Wilson",
    "position": "QB",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "bo-melton",
    "name": "Bo Melton",
    "position": "WR",
    "team": "GBP",
    "imageUrl": ""
  },
  {
    "id": "zach-ertz",
    "name": "Zach Ertz",
    "position": "TE",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "sam-howell",
    "name": "Sam Howell",
    "position": "QB",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "jordan-watkins",
    "name": "Jordan Watkins",
    "position": "WR",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "jonathan-mingo",
    "name": "Jonathan Mingo",
    "position": "WR",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "tyrell-shavers",
    "name": "Tyrell Shavers",
    "position": "WR",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "liljordan-humphrey",
    "name": "Lil'Jordan Humphrey",
    "position": "WR",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "arian-smith",
    "name": "Arian Smith",
    "position": "WR",
    "team": "NYJ",
    "imageUrl": ""
  },
  {
    "id": "tyler-badie",
    "name": "Tyler Badie",
    "position": "RB",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "kareem-hunt",
    "name": "Kareem Hunt",
    "position": "RB",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "brevin-jordan",
    "name": "Brevin Jordan",
    "position": "TE",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "charlie-kolar",
    "name": "Charlie Kolar",
    "position": "TE",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "brock-wright",
    "name": "Brock Wright",
    "position": "TE",
    "team": "DET",
    "imageUrl": ""
  },
  {
    "id": "mason-tipton",
    "name": "Mason Tipton",
    "position": "WR",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "dameon-pierce",
    "name": "Dameon Pierce",
    "position": "RB",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "sione-vaki",
    "name": "Sione Vaki",
    "position": "RB",
    "team": "DET",
    "imageUrl": ""
  },
  {
    "id": "israel-abanikanda",
    "name": "Israel Abanikanda",
    "position": "RB",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "jared-wiley",
    "name": "Jared Wiley",
    "position": "TE",
    "team": "KCC",
    "imageUrl": ""
  },
  {
    "id": "kenny-mcintosh",
    "name": "Kenny McIntosh",
    "position": "RB",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "tyler-scott",
    "name": "Tyler Scott",
    "position": "WR",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "hassan-haskins",
    "name": "Hassan Haskins",
    "position": "RB",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "drew-lock",
    "name": "Drew Lock",
    "position": "QB",
    "team": "SEA",
    "imageUrl": ""
  },
  {
    "id": "nick-westbrook-ikhine",
    "name": "Nick Westbrook-Ikhine",
    "position": "WR",
    "team": "IND",
    "imageUrl": ""
  },
  {
    "id": "skyy-moore",
    "name": "Skyy Moore",
    "position": "WR",
    "team": "GBP",
    "imageUrl": ""
  },
  {
    "id": "darren-waller",
    "name": "Darren Waller",
    "position": "TE",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "davis-allen",
    "name": "Davis Allen",
    "position": "TE",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "deuce-vaughn",
    "name": "Deuce Vaughn",
    "position": "RB",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "cam-akers",
    "name": "Cam Akers",
    "position": "RB",
    "team": "FA",
    "imageUrl": ""
  },
  {
    "id": "elijah-mitchell",
    "name": "Elijah Mitchell",
    "position": "RB",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "xavier-gipson",
    "name": "Xavier Gipson",
    "position": "WR",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "jamari-thrash",
    "name": "Jamari Thrash",
    "position": "WR",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "jawhar-jordan",
    "name": "Jawhar Jordan",
    "position": "RB",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "isaiah-hodgins",
    "name": "Isaiah Hodgins",
    "position": "WR",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "leveon-moss",
    "name": "Le'Veon Moss",
    "position": "RB",
    "team": "FA",
    "imageUrl": ""
  },
  {
    "id": "bub-means",
    "name": "Bub Means",
    "position": "WR",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "demarcus-robinson",
    "name": "Demarcus Robinson",
    "position": "WR",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "drew-allar",
    "name": "Drew Allar",
    "position": "QB",
    "team": "PIT",
    "imageUrl": ""
  },
  {
    "id": "carson-beck",
    "name": "Carson Beck",
    "position": "QB",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "ty-chandler",
    "name": "Ty Chandler",
    "position": "RB",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "frank-gore-jr",
    "name": "Frank Gore Jr.",
    "position": "RB",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "aidan-oconnell",
    "name": "Aidan O'Connell",
    "position": "QB",
    "team": "LVR",
    "imageUrl": ""
  },
  {
    "id": "zavier-scott",
    "name": "Zavier Scott",
    "position": "RB",
    "team": "MIN",
    "imageUrl": ""
  },
  {
    "id": "tyler-johnson",
    "name": "Tyler Johnson",
    "position": "WR",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "grant-calcaterra",
    "name": "Grant Calcaterra",
    "position": "TE",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "mason-rudolph",
    "name": "Mason Rudolph",
    "position": "QB",
    "team": "PIT",
    "imageUrl": ""
  },
  {
    "id": "ainias-smith",
    "name": "Ainias Smith",
    "position": "WR",
    "team": "CAR",
    "imageUrl": ""
  },
  {
    "id": "deion-burks",
    "name": "Deion Burks",
    "position": "WR",
    "team": "IND",
    "imageUrl": ""
  },
  {
    "id": "david-bell",
    "name": "David Bell",
    "position": "WR",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "alexander-mattison",
    "name": "Alexander Mattison",
    "position": "RB",
    "team": "MIA",
    "imageUrl": ""
  },
  {
    "id": "kendall-milton",
    "name": "Kendall Milton",
    "position": "RB",
    "team": "CIN",
    "imageUrl": ""
  },
  {
    "id": "samaje-perine",
    "name": "Samaje Perine",
    "position": "RB",
    "team": "CIN",
    "imageUrl": ""
  },
  {
    "id": "miles-sanders",
    "name": "Miles Sanders",
    "position": "RB",
    "team": "DAL",
    "imageUrl": ""
  },
  {
    "id": "nick-chubb",
    "name": "Nick Chubb",
    "position": "RB",
    "team": "HOU",
    "imageUrl": ""
  },
  {
    "id": "khalil-herbert",
    "name": "Khalil Herbert",
    "position": "RB",
    "team": "NYJ",
    "imageUrl": ""
  },
  {
    "id": "jam-miller",
    "name": "Jam Miller",
    "position": "RB",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "jeremy-mcnichols",
    "name": "Jeremy McNichols",
    "position": "RB",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "terrell-jennings",
    "name": "Terrell Jennings",
    "position": "RB",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "jeremy-ruckert",
    "name": "Jeremy Ruckert",
    "position": "TE",
    "team": "NYJ",
    "imageUrl": ""
  },
  {
    "id": "deandre-hopkins",
    "name": "DeAndre Hopkins",
    "position": "WR",
    "team": "BAL",
    "imageUrl": ""
  },
  {
    "id": "brenden-rice",
    "name": "Brenden Rice",
    "position": "WR",
    "team": "LVR",
    "imageUrl": ""
  },
  {
    "id": "jmari-taylor",
    "name": "J'Mari Taylor",
    "position": "RB",
    "team": "JAC",
    "imageUrl": ""
  },
  {
    "id": "bryce-lance",
    "name": "Bryce Lance",
    "position": "WR",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "seth-mcgowan",
    "name": "Seth McGowan",
    "position": "RB",
    "team": "IND",
    "imageUrl": ""
  },
  {
    "id": "zay-jones",
    "name": "Zay Jones",
    "position": "WR",
    "team": "ARI",
    "imageUrl": ""
  },
  {
    "id": "cj-daniels",
    "name": "CJ Daniels",
    "position": "WR",
    "team": "LAR",
    "imageUrl": ""
  },
  {
    "id": "jermaine-burton",
    "name": "Jermaine Burton",
    "position": "WR",
    "team": "FA",
    "imageUrl": ""
  },
  {
    "id": "thomas-fidone",
    "name": "Thomas Fidone",
    "position": "TE",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "van-jefferson",
    "name": "Van Jefferson",
    "position": "WR",
    "team": "WAS",
    "imageUrl": ""
  },
  {
    "id": "hunter-long",
    "name": "Hunter Long",
    "position": "TE",
    "team": "JAC",
    "imageUrl": ""
  },
  {
    "id": "oscar-delp",
    "name": "Oscar Delp",
    "position": "TE",
    "team": "NOS",
    "imageUrl": ""
  },
  {
    "id": "curtis-samuel",
    "name": "Curtis Samuel",
    "position": "WR",
    "team": "FA",
    "imageUrl": ""
  },
  {
    "id": "ray-ray-mccloud",
    "name": "Ray-Ray McCloud",
    "position": "WR",
    "team": "NYG",
    "imageUrl": ""
  },
  {
    "id": "johnny-wilson",
    "name": "Johnny Wilson",
    "position": "WR",
    "team": "PHI",
    "imageUrl": ""
  },
  {
    "id": "josh-oliver",
    "name": "Josh Oliver",
    "position": "TE",
    "team": "MIN",
    "imageUrl": ""
  },
  {
    "id": "antonio-gibson",
    "name": "Antonio Gibson",
    "position": "RB",
    "team": "FA",
    "imageUrl": ""
  },
  {
    "id": "jack-endries",
    "name": "Jack Endries",
    "position": "TE",
    "team": "CIN",
    "imageUrl": ""
  },
  {
    "id": "tim-patrick",
    "name": "Tim Patrick",
    "position": "WR",
    "team": "JAC",
    "imageUrl": ""
  },
  {
    "id": "tyler-lockett",
    "name": "Tyler Lockett",
    "position": "WR",
    "team": "LVR",
    "imageUrl": ""
  },
  {
    "id": "kaelon-black",
    "name": "Kaelon Black",
    "position": "RB",
    "team": "SFO",
    "imageUrl": ""
  },
  {
    "id": "zavion-thomas",
    "name": "Zavion Thomas",
    "position": "WR",
    "team": "CHI",
    "imageUrl": ""
  },
  {
    "id": "justin-joly",
    "name": "Justin Joly",
    "position": "TE",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "eli-raridon",
    "name": "Eli Raridon",
    "position": "TE",
    "team": "NEP",
    "imageUrl": ""
  },
  {
    "id": "brenen-thompson",
    "name": "Brenen Thompson",
    "position": "WR",
    "team": "LAC",
    "imageUrl": ""
  },
  {
    "id": "sam-roush",
    "name": "Sam Roush",
    "position": "TE",
    "team": "CHI",
    "imageUrl": ""
  },
  {
    "id": "nate-boerkircher",
    "name": "Nate Boerkircher",
    "position": "TE",
    "team": "JAC",
    "imageUrl": ""
  },
  {
    "id": "pat-bryant",
    "name": "Pat Bryant",
    "position": "WR",
    "team": "DEN",
    "imageUrl": ""
  },
  {
    "id": "keon-coleman-2",
    "name": "Keon Coleman",
    "position": "WR",
    "team": "BUF",
    "imageUrl": ""
  },
  {
    "id": "tylan-wallace",
    "name": "Tylan Wallace",
    "position": "WR",
    "team": "CLE",
    "imageUrl": ""
  },
  {
    "id": "kyle-mccord",
    "name": "Kyle McCord",
    "position": "QB",
    "team": "GBP",
    "imageUrl": ""
  }
];

export const rankingIds: string[] = [
  "bijan-robinson",
  "josh-allen",
  "jamarr-chase",
  "jaxon-smith-njigba",
  "jahmyr-gibbs",
  "drake-maye",
  "puka-nacua",
  "brock-bowers",
  "malik-nabers",
  "jayden-daniels",
  "caleb-williams",
  "justin-jefferson",
  "amon-ra-st-brown",
  "lamar-jackson",
  "ashton-jeanty",
  "jeremiyah-love",
  "trey-mcbride",
  "joe-burrow",
  "ceedee-lamb",
  "drake-london",
  "patrick-mahomes",
  "devon-achane",
  "justin-herbert",
  "omarion-hampton",
  "tetairoa-mcmillan",
  "jaxson-dart",
  "bo-nix",
  "trevor-lawrence",
  "jalen-hurts",
  "james-cook",
  "emeka-egbuka",
  "colston-loveland",
  "jonathan-taylor",
  "george-pickens",
  "brock-purdy",
  "garrett-wilson",
  "tyler-warren",
  "jordan-love",
  "carnell-tate",
  "fernando-mendoza",
  "nico-collins",
  "chris-olave",
  "kenneth-walker-iii",
  "treveyon-henderson",
  "quinshon-judkins",
  "ladd-mcconkey",
  "rome-odunze",
  "breece-hall",
  "luther-burden",
  "cam-ward",
  "rashee-rice",
  "jordyn-tyson",
  "devonta-smith",
  "makai-lemon",
  "marvin-harrison-jr",
  "christian-mccaffrey",
  "bucky-irving",
  "brian-thomas-jr",
  "saquon-barkley",
  "dak-prescott",
  "cj-stroud",
  "chase-brown",
  "jaylen-waddle",
  "kyren-williams",
  "tee-higgins",
  "harold-fannin",
  "aj-brown",
  "tyler-shough",
  "baker-mayfield",
  "tucker-kraft",
  "jameson-williams",
  "sam-darnold",
  "zay-flowers",
  "jared-goff",
  "sam-laporta",
  "jadarian-price",
  "bryce-young",
  "josh-jacobs",
  "cam-skattebo",
  "travis-etienne",
  "javonte-williams",
  "kyle-pitts",
  "kc-concepcion",
  "alec-pierce",
  "kyler-murray",
  "malik-willis",
  "kenyon-sadiq",
  "daniel-jones",
  "jordan-addison",
  "bhayshul-tuten",
  "oronde-gadsden",
  "derrick-henry",
  "omar-cooper-jr",
  "dj-moore",
  "matthew-golden",
  "dk-metcalf",
  "rj-harvey",
  "michael-wilson",
  "ty-simpson",
  "matthew-stafford",
  "christian-watson",
  "wandale-robinson",
  "kyle-monangai",
  "dandre-swift",
  "jayden-higgins",
  "ricky-pearsall",
  "zach-charbonnet",
  "terry-mclaurin",
  "parker-washington",
  "davante-adams",
  "josh-downs",
  "eli-stowers",
  "george-kittle",
  "quentin-johnston",
  "xavier-worthy",
  "denzel-boston",
  "michael-pittman",
  "david-montgomery",
  "isaiah-likely",
  "chuba-hubbard",
  "jayden-reed",
  "romeo-doubs",
  "mike-evans",
  "travis-hunter",
  "jake-ferguson",
  "courtland-sutton",
  "jakobi-meyers",
  "dalton-kincaid",
  "blake-corum",
  "rico-dowdle",
  "jaylen-warren",
  "michael-penix-jr",
  "jk-dobbins",
  "rashid-shaheed",
  "jalen-coker",
  "jalen-mcmillan",
  "brenton-strange",
  "jonathon-brooks",
  "khalil-shakir",
  "jj-mccarthy",
  "chris-godwin",
  "woody-marks",
  "rhamondre-stevenson",
  "jacory-croskey-merritt",
  "aj-barner",
  "kenneth-gainwell",
  "jonah-coleman",
  "shedeur-sanders",
  "tj-hockenson",
  "chigoziem-okonkwo",
  "nicholas-singleton",
  "isaac-teslaa",
  "mark-andrews",
  "kayshon-boutte",
  "tua-tagovailoa",
  "mac-jones",
  "troy-franklin",
  "tony-pollard",
  "tre-harris",
  "tyler-allgeier",
  "dylan-sampson",
  "jaylin-noel",
  "jacoby-brissett",
  "elic-ayomanor",
  "chris-bell",
  "tory-horton",
  "terrance-ferguson",
  "jerry-jeudy",
  "tyjae-spears",
  "rachaad-white",
  "gunnar-helm",
  "jordan-mason",
  "jauan-jennings",
  "chimere-dike",
  "braelon-allen",
  "germie-bernard",
  "tyrone-tracy",
  "dontayvion-wicks",
  "dallas-goedert",
  "chris-brazzell-ii",
  "adonai-mitchell",
  "tre-tucker",
  "elijah-arroyo",
  "keon-coleman",
  "mike-washington-jr",
  "brandon-aiyuk",
  "kaleb-johnson",
  "kyle-williams",
  "ollie-gordon",
  "keaton-mitchell",
  "tank-bigsby",
  "chris-rodriguez",
  "malik-washington",
  "mason-taylor",
  "david-njoku",
  "brian-robinson",
  "travis-kelce",
  "jack-bech",
  "deebo-samuel",
  "malachi-fields",
  "tank-dell",
  "anthony-richardson",
  "jalen-nailor",
  "zachariah-branch",
  "jalen-milroe",
  "jake-tonges",
  "theo-johnson",
  "juwan-johnson",
  "hunter-henry",
  "cade-otton",
  "trey-benson",
  "sean-tucker",
  "kimani-vidal",
  "isiah-pacheco",
  "jaylen-wright",
  "marvin-mims",
  "dalton-schultz",
  "emmett-johnson",
  "skyler-bell",
  "aaron-jones",
  "tez-johnson",
  "michael-mayer",
  "jakobi-lane",
  "devin-neal",
  "kaytron-allen",
  "trevor-etienne",
  "stefon-diggs",
  "isaiah-bond",
  "darnell-mooney",
  "justin-fields",
  "tyreek-hill",
  "pat-freiermuth",
  "geno-smith",
  "emanuel-wilson",
  "antonio-williams",
  "donte-thornton",
  "jordan-james",
  "jatavion-sanders",
  "cole-kmet",
  "rashod-bateman",
  "lequint-allen",
  "xavier-legette",
  "dj-giddens",
  "christian-kirk",
  "alvin-kamara",
  "jaydon-blue",
  "demario-douglas",
  "colby-parkinson",
  "james-conner",
  "will-howard",
  "cedric-tillman",
  "ray-davis",
  "kirk-cousins",
  "jaylin-lane",
  "kendre-miller",
  "calvin-ridley",
  "brashard-smith",
  "evan-engram",
  "darnell-washington",
  "deshaun-watson",
  "quinn-ewers",
  "luke-musgrave",
  "najee-harris",
  "marshawn-lloyd",
  "tyquan-thornton",
  "jalen-tolbert",
  "ben-sinnott",
  "cooper-kupp",
  "aaron-rodgers",
  "jalen-royals",
  "riley-leonard",
  "isaiah-davis",
  "marquise-brown",
  "xavier-hutchinson",
  "garrett-nussmeier",
  "jahan-dotson",
  "dawson-knox",
  "tutu-atwell",
  "spencer-rattler",
  "savion-williams",
  "max-klare",
  "ryan-flournoy",
  "greg-dulcich",
  "luke-mccaffrey",
  "joe-milton",
  "jarquez-hunter",
  "ted-hurst",
  "roman-wilson",
  "andrei-iosivas",
  "tahj-brooks",
  "john-metchie",
  "will-shipley",
  "devaughn-vele",
  "joshua-palmer",
  "audric-estime",
  "keandre-lambert-smith",
  "noah-gray",
  "isaac-guerendo",
  "jimmy-horn",
  "treylon-burks",
  "jordan-whittington",
  "keenan-allen",
  "calvin-austin-iii",
  "roschon-johnson",
  "jerome-ford",
  "darius-slayton",
  "tahj-washington",
  "dillon-gabriel",
  "will-levis",
  "jalynn-polk",
  "jaleel-mclaughlin",
  "jameis-winston",
  "tyson-bagent",
  "davis-mills",
  "daniel-bellinger",
  "kendrick-bourne",
  "marcus-mariota",
  "konata-mumpfield",
  "dyami-brown",
  "noah-fant",
  "cade-stover",
  "devontez-walker",
  "raheim-sanders",
  "efton-chism",
  "mike-gesicki",
  "tommy-tremble",
  "tyler-higbee",
  "devin-singletary",
  "cade-klubnik",
  "kevin-coleman",
  "george-holani",
  "xavier-restrepo",
  "damien-martinez",
  "ty-johnson",
  "justice-hill",
  "elijah-moore",
  "malik-davis",
  "jalin-hyatt",
  "demond-claiborne",
  "olamide-zaccheaus",
  "tanner-mckee",
  "tai-felton",
  "erick-all",
  "greg-dortch",
  "phil-mafah",
  "luke-schoonmaker",
  "bam-knight",
  "malachi-corley",
  "elijah-higgins",
  "tyler-huntley",
  "kameron-johnson",
  "emari-demercado",
  "trey-palmer",
  "joe-mixon",
  "jonnu-smith",
  "joe-flacco",
  "kavontae-turpin",
  "donovan-edwards",
  "mack-hollins",
  "mitchell-evans",
  "gardner-minshew",
  "trey-lance",
  "kenny-pickett",
  "tyler-goodson",
  "chris-brooks",
  "michael-trigg",
  "dezhaun-stribling",
  "jake-bobo",
  "michael-carter",
  "gabriel-davis",
  "rasheen-ali",
  "kalel-mullings",
  "jacob-cowing",
  "javon-baker",
  "zach-wilson",
  "bo-melton",
  "zach-ertz",
  "sam-howell",
  "jordan-watkins",
  "jonathan-mingo",
  "tyrell-shavers",
  "liljordan-humphrey",
  "arian-smith",
  "tyler-badie",
  "kareem-hunt",
  "brevin-jordan",
  "charlie-kolar",
  "brock-wright",
  "mason-tipton",
  "dameon-pierce",
  "sione-vaki",
  "israel-abanikanda",
  "jared-wiley",
  "kenny-mcintosh",
  "tyler-scott",
  "hassan-haskins",
  "drew-lock",
  "nick-westbrook-ikhine",
  "skyy-moore",
  "darren-waller",
  "davis-allen",
  "deuce-vaughn",
  "cam-akers",
  "elijah-mitchell",
  "xavier-gipson",
  "jamari-thrash",
  "jawhar-jordan",
  "isaiah-hodgins",
  "leveon-moss",
  "bub-means",
  "demarcus-robinson",
  "drew-allar",
  "carson-beck",
  "ty-chandler",
  "frank-gore-jr",
  "aidan-oconnell",
  "zavier-scott",
  "tyler-johnson",
  "grant-calcaterra",
  "mason-rudolph",
  "ainias-smith",
  "deion-burks",
  "david-bell",
  "alexander-mattison",
  "kendall-milton",
  "samaje-perine",
  "miles-sanders",
  "nick-chubb",
  "khalil-herbert",
  "jam-miller",
  "jeremy-mcnichols",
  "terrell-jennings",
  "jeremy-ruckert",
  "deandre-hopkins",
  "brenden-rice",
  "jmari-taylor",
  "bryce-lance",
  "seth-mcgowan",
  "zay-jones",
  "cj-daniels",
  "jermaine-burton",
  "thomas-fidone",
  "van-jefferson",
  "hunter-long",
  "oscar-delp",
  "curtis-samuel",
  "ray-ray-mccloud",
  "johnny-wilson",
  "josh-oliver",
  "antonio-gibson",
  "jack-endries",
  "tim-patrick",
  "tyler-lockett",
  "kaelon-black",
  "zavion-thomas",
  "justin-joly",
  "eli-raridon",
  "brenen-thompson",
  "sam-roush",
  "nate-boerkircher",
  "pat-bryant",
  "keon-coleman-2",
  "tylan-wallace",
  "kyle-mccord"
];
